import styled from 'styled-components'
import { Link } from 'react-router-dom'

const A = styled(Link)`
  text-decoration: none;
`

export default A
